<template>
  <div class="plan-summary-card">
    <h2>Plan Summary</h2>
    <BittsCallout
      v-if="!blockSalesSeatsPPV5 && isTrueConnector && isLegacyConnectorPPv5"
      action-text="Learn more"
      class="mb-16"
      type="neutral"
      title="You're on a legacy version of this plan"
      subtitle="You currently have access to some features and pricing benefits no longer available on the new Connector plan."
      @bitts-callout-action="onLearnMore"
    />
    <BittsContainer class="plan-summary-card__card">
      <PlanSummary
        :show-platform-upsell="showPlatformUpsell"
        @view-billing="() => toggleViewBilling(true)"
      />
      <ManageSeats />
    </BittsContainer>
    <ViewBillingModal
      v-if="viewBillingModalVisible"
      :visible="viewBillingModalVisible"
      @closed="() => toggleViewBilling(false)"
    />
  </div>
</template>

<script setup lang="ts">
import { BittsCallout, BittsContainer } from '@crossbeam/bitts';

import { storeToRefs } from 'pinia';
import { ref } from 'vue';

import ManageSeats from '@/components/billing/ManageSeats.vue';
import PlanSummary from '@/components/billing/PlanSummary.vue';
import ViewBillingModal from '@/components/billing/ViewBillingModal.vue';

import { useConnectorTrialEndDate } from '@/composables/useConnectorTrialEndDate';
import useSeats from '@/composables/useSeats';
import { useBillingStore } from '@/stores';

const { showPlatformUpsell = false } = defineProps<{
  showPlatformUpsell?: boolean;
}>();
const { blockSalesSeatsPPV5 } = useSeats();
const { isTrueConnector } = useConnectorTrialEndDate();

const billingStore = useBillingStore();
const { isLegacyConnectorPPv5 } = storeToRefs(billingStore);

const viewBillingModalVisible = ref(false);

function toggleViewBilling(visible: boolean) {
  viewBillingModalVisible.value = visible;
}

function onLearnMore() {
  window.open(
    'https://help.crossbeam.com/en/articles/10592157-upcoming-pricing-and-packaging-changes-crossbeam-connector-plan',
    '_blank',
  );
}
</script>

<style scoped lang="pcss">
@reference "../../css/theme.css";
.plan-summary-card {
  @apply flex flex-col gap-16 mb-40;
}
.plan-summary-card__card {
  @apply grid grid-cols-2 p-0;
}

section {
  @apply p-24 flex flex-col gap-4 items-start;
  &:last-child {
    @apply border-solid border-l border-neutral-border;
  }
}

h2,
:deep(h2) {
  @apply font-bold text-lg text-neutral-text-strong;
}
:deep(h2) {
  @apply text-m;
}
:deep(h4) {
  @apply text-neutral-text-weak;
}
:deep(p) {
  @apply text-neutral-text-weak;
}
</style>
